import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconCommunicationCall16 } from '@cian/ui-kit-design-tokens/icons';

import { useCallbackButton } from './useCallbackButton';

export function HeaderCallbackButton() {
  const [isAvailable, handleClick, isLoading] = useCallbackButton('blockStickytop');

  if (!isAvailable) {
    return null;
  }

  return (
    <Button
      theme="fill_secondary"
      size="XS"
      onClick={handleClick}
      beforeIcon={<IconCommunicationCall16 color={'icon-main-default'} />}
      loading={isLoading}
      aria-label="Заказ звонка"
      data-testid="HeaderCallbackButton"
    />
  );
}
